module.exports = __webpack_public_path__ + "img/icon_student.a625ea8e.png";